import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  Divider,
  Button,
  TextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const AllQuestions = () => {
  // Sample questions data
  const questions = [
    {
      id: 1,
      title: "How to fix a broken screen?",
      author: "John Doe",
      date: "2024-03-20",
      replies: 5
    },
    {
      id: 2,
      title: "Battery replacement guide for iPhone",
      author: "Jane Smith",
      date: "2024-03-19",
      replies: 3
    },
    {
      id: 3,
      title: "Laptop not turning on",
      author: "Mike Johnson",
      date: "2024-03-18",
      replies: 8
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          All Questions
        </Typography>
        
        {/* Search Bar */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          mb: 4 
        }}>
          <TextField
            fullWidth
            placeholder="Search questions..."
            size="small"
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
            }}
          />
          <Button 
            variant="contained" 
            sx={{ 
              bgcolor: '#007C3F',
              '&:hover': {
                bgcolor: '#005C2F'
              }
            }}
          >
            Ask Question
          </Button>
        </Box>
      </Box>

      {/* Questions List */}
      <Paper elevation={1}>
        <List>
          {questions.map((question, index) => (
            <React.Fragment key={question.id}>
              <ListItem 
                sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'flex-start',
                  py: 2
                }}
              >
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: '#007C3F',
                    cursor: 'pointer',
                    '&:hover': {
                      color: '#005C2F'
                    }
                  }}
                >
                  {question.title}
                </Typography>
                <Box sx={{ 
                  display: 'flex', 
                  gap: 2,
                  mt: 1,
                  color: 'text.secondary',
                  fontSize: '0.875rem'
                }}>
                  <span>Asked by {question.author}</span>
                  <span>•</span>
                  <span>{question.date}</span>
                  <span>•</span>
                  <span>{question.replies} replies</span>
                </Box>
              </ListItem>
              {index < questions.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Container>
  );
};

export default AllQuestions; 